import { createSlice } from '@reduxjs/toolkit';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
  progressing: false,
  progressingDocument: false,
};

const employeeProfileSlice = createSlice({
  name: 'employeeProfile',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
    setProgressing(state, action) {
      state.progressing = action.payload;
    },
    setProgressingDocument(state, action) {
      state.progressingDocument = action.payload;
    },
  },
});

const token = JSON.parse(localStorage.getItem('authenticated'));

const { setFormLoading, setProgressing, setProgressingDocument } = employeeProfileSlice.actions;

export const { setRecord } = employeeProfileSlice.actions;

export const initPageInfo = () => async (dispatch) => {
  try {
    dispatch(setFormLoading(true));

    let url = `/employee-profile/index-info?`;
    url += `auth_token=${token}`;

    RequestApi(url, {})
      .then((res) => {
        if (res.data.status === 'success') {
          dispatch(setRecord(res.data.record));
        } else {
          NotificationMessage({ message: res.data.msg, status: res.data.status });
        }

        dispatch(setFormLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setFormLoading(false));
        NotificationMessage({ message: err.toString(), status: 'error' });
      });
  } catch (ex) {
    dispatch(setFormLoading(false));
    NotificationMessage({ message: ex.toString(), status: 'error' });
  }
};

export const updateRecord =
  ({ unid, fieldName, valueChanged, record }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));
      dispatch(setProgressing(true));

      let urlRequest = `/employee-profile/update-record?`;
      urlRequest += `auth_token=${token}`;
      urlRequest += '&source_type=portal';

      const data = JSON.stringify({
        field_name: fieldName,
        value: valueChanged,
        unid,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };

            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });

            dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

const employeeProfileReducer = employeeProfileSlice.reducer;

export default employeeProfileReducer;
